import { createActionCreator } from '../actions/actionCreators';
import { SoftphoneCall } from './softphone.model';

export const softphoneCallStarted = createActionCreator('softphoneCall/started')<SoftphoneCall>();
export const softphoneCallUpdated = createActionCreator('softphoneCall/updated')<SoftphoneCall>();
export const softphoneCallEnded = createActionCreator('softphoneCall/ended')<SoftphoneCall>();
